<template>
    <el-table
            :data="tableData"
            ref="dataTable"
            highlight-current-row
            size="mini"
            @selection-change="handleSelectionChange"
            border>
        <el-table-column
                v-if="isShowSelect"
                type="selection"
                width="55">
        </el-table-column>
        <el-table-column
                fixed
                prop="number"
                label="期数">
        </el-table-column>
        <el-table-column
                prop="finishPrice"
                label="完成产值">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.finishPrice) }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="calculatePrice"
                label="计量金额">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.calculatePrice) }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="applyTime"
                label="申请日期"
                width="120">
        </el-table-column>
        <el-table-column
                prop="replyTime"
                label="批复日期"
                width="120">
        </el-table-column>
        <el-table-column
                prop="replyPrice"
                label="批复金额">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.replyPrice) }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="billPrice"
                label="开具发票金额"
                width="120">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.billPrice) }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="outputTaxPrice"
                label="销项税金额"
                width="120">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.outputTaxPrice) }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="receiptPrice"
                label="收款金额">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.receiptPrice) }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="finishPriceRate"
                label="完成产值占合同比例（%）"
                width="180">
        </el-table-column>
        <el-table-column
                prop="calculatePriceRate"
                label="计量金额占合同比例（%）"
                width="180">
        </el-table-column>
        <el-table-column
                prop="replyPriceRate"
                label="已批复产值占合同比例（%）"
                width="180">
        </el-table-column>
        <el-table-column
                prop="receiptPriceRate"
                label="已收款占合同额比例（%）"
                width="180">
        </el-table-column>
        <el-table-column
                prop="receiptPlanPrice"
                label="应收账款">
            <template slot-scope="scope">
                <span>{{ formatMoneyNumber(scope.row.receiptPlanPrice) }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    import {formatMoney} from "../../finance/utils";
    export default {
        name: "collection-records",
        data(){
            return {
                multipleSelection: []
            }
        },
        props:{
            tableData:{  //审批类型
                type: Array,
                default: ()=> []
            },
            isShowSelect: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            formatMoneyNumber: formatMoney,
        }
    }
</script>

<style scoped>

</style>
